import React from 'react';
import Button from './Button';

export default function SubmitButton(props) {
  return <Button htmlType="submit" type="primary" {...props} />;
}
